// stores/authStore.js
import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useAuthStore = defineStore(
  "aanzaUserAuthStore",
  () => {
    // --- State ---
    const user = ref(null);
    const token = ref(null);
    const shopId = ref(null);
    const tableId = ref(null);

    // --- Getters ---
    const isAuthenticated = computed(() => !!token.value);
    const getShopId = computed(() => shopId.value);
    const getTableId = computed(() => tableId.value);

    // --- Actions ---
    async function fetchUser() {
      if (!token.value) return;
      try {
        //TODO check User
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      }
    }

    function setToken(newToken) {
      token.value = newToken;
    }

    function setUser(newUser) {
      user.value = newUser;
    }

    function setShopId(id) {
      shopId.value = parseInt(id, 10) || null;
    }

    function setTableId(id) {
      tableId.value = parseInt(id, 10) || null;
    }

    // Handle Login
    function login(userData, authToken) {
      setUser(userData);
      setToken(authToken);
      return navigateTo("/cart", { replace: true });
    }

    // Handle Logout
    function logout() {
      token.value = null;
      user.value = null;
      shopId.value = null;
      tableId.value = null;
      return navigateTo("/login");
    }

    return {
      user,
      fetchUser,
      token,
      shopId,
      tableId,
      isAuthenticated,
      getShopId,
      getTableId,
      login,
      logout,
      setToken,
      setUser,
      setShopId,
      setTableId,
    };
  },
  {
    persist: true,
  },
);
